// extracted by mini-css-extract-plugin
export default {"answersList":"bz_b6"};